<div
    #wrapper
    role="group"
    class="se-date-range"
    [attr.aria-labelledby]="formField?.getLabelId()"
    (click)="onContainerClick($event)"
>
    <mat-form-field appearance="outline" class="se-form-field">
        <mat-label>{{ placeholder }}</mat-label>
        <mat-date-range-input
            [formGroup]="form"
            [rangePicker]="picker"
            se-autofocus
            [autofocus]="autofocus"
            (focusin)="onFocusIn($event)"
            (focusout)="onFocusOut($event)"
        >
            <input matStartDate formControlName="from" [placeholder]="placeholderStartDate" />
            <input matEndDate formControlName="to" [placeholder]="placeholderEndDate" />
        </mat-date-range-input>
        <mat-hint *ngIf="showHint">{{ getDateFormat() }} – {{ getDateFormat() }}</mat-hint>
        <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
        <mat-date-range-picker #picker></mat-date-range-picker>
        <mat-error *ngIf="hasStartDateError()">Invalid start date</mat-error>
        <mat-error *ngIf="hasEndDateError()">Invalid end date</mat-error>
    </mat-form-field>
    <div class="actions" [class.focused]="focused">
        <button mat-mini-fab color="unthemed" aria-label="Empty" [disableRipple]="true" (click)="reset()">
            <mat-icon>close</mat-icon>
        </button>
        <button
            mat-mini-fab
            color="unthemed"
            aria-label="Select interval"
            [disableRipple]="true"
            [matMenuTriggerFor]="dataRangeIntervalMenu"
        >
            <mat-icon>play_arrow</mat-icon>
        </button>
        <mat-menu #dataRangeIntervalMenu="matMenu" yPosition="below" xPosition="after">
            <div *ngFor="let interval of predefiniteIntervals">
                <button mat-menu-item class="se-menu-button" (click)="setPredefiniteInterval(interval)">
                    <span>{{ getLabelForInterval(interval) }}</span>
                </button>
            </div>
        </mat-menu>
    </div>
</div>
